import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import LibTypeArrays from "crypto-js/lib-typedarrays";
import Axios from 'axios';

export const getCodeVerifier = () => {
    const fromStorage = localStorage.getItem('code_verifier');
    if (fromStorage === null) {
        const newCodeVerifier = LibTypeArrays.random(64);
        localStorage.setItem('code_verifier', newCodeVerifier);
    }
    return localStorage.getItem('code_verifier') || '';
}

export const getCodeChallege = () => {
    var codeVerifier = getCodeVerifier();
    var hashed = sha256(codeVerifier);
    var base64 = Base64.stringify(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return base64;
}

export const ssoObj = {
    responseType: "code",
    state: "init",
    genGrantType: "authorization_code",
    reGenGrantType: "refresh_token",
    clientId: process.env.SSO_OBE_CLIENT_ID,
    clientSecret: process.env.SSO_OBE_CLIENT_SECRET,
    codeChallengeMethod: "SHA256",
    ssoDomain: "https://accounts.justdial.com"
}

export const redirectUrlFunc = () => {
    const match = window.location.pathname.match(/^(.*\/obe-login)(\/|$)/);
    return window.location.origin + (match ? match[1] : window.location.pathname)
}

export const storeDocId = (docId) => {
    if (docId) {
        localStorage.setItem('obe_login_docId', docId);
    }
}

export const getStoredDocId = () => {
    return localStorage.getItem('obe_login_docId') || '';
}

export const clearStoredDocId = () => {
    localStorage.removeItem('obe_login_docId');
}

export const tokenApi = (payload, cb) => {
    const url = `${ssoObj.ssoDomain}/jdiam/api/token`
    const urlencoded = new URLSearchParams(payload);
    const header = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    Axios.post(url, urlencoded, header).then(rsp => {
        const data = rsp.data;
        if (data.access_token) {
            cb({ status: 1, data })
        } else {
            cb({ status: 0, data })
        }
    }).catch(err => {
        cb({ status: 0, data: {}, msg: err.response?.data || err.message || "Something went wrong." })
    })
}

export const tokenVerify = (token, aToken = null, fromGenioLite = null, cb,env) => {
    const params = [];
    if (aToken) {
        params.push(`a_token=${aToken}`);
    }
    if (fromGenioLite) {
        params.push(`fromGenioLite=${fromGenioLite}`);
    }
    if (env) {
        params.push(`env=${env}`);
    }
    const url = `/vendor/manage-products-genio/${token}/api/verifyObeToken.ns` + (params.length ? `?${params.join('&')}` : '');
    Axios.get(url).then(rsp => {
        const data = rsp.data;
        if (data.status) {
            cb({ status: 1, data: data.data })
        } else {
            cb({ status: 0, data })
        }
    }).catch(err => {
        cb({ status: 0, data: {}, msg: err.response?.data || err.message || "Something went wrong." })
    })
}

export const redirectToSSO = () => {
    const codeChallege = getCodeChallege()
    const url = `${ssoObj.ssoDomain}/jdiam/auth`
    const redirectUrl = redirectUrlFunc()
    const queryParam = `?response_type=${ssoObj.responseType}&client_id=${ssoObj.clientId}&redirect_uri=${redirectUrl}&state=${ssoObj.state}&code_challenge=${codeChallege}&code_challenge_method=${ssoObj.codeChallengeMethod}`
    const inIFrame = (window.top != window.self) ? true : undefined;
    if (inIFrame) {
        window.top.location.href = url + queryParam
    } else {
        window.location.href = url + queryParam
    }
}

export const findTokenByDocId = (docId, empCode, cb) => {
    Axios.get(`/vendorapis/products/ajax/getDocidToken?docid=${docId}&empcode=${empCode}`).then(rsp => {
        const data = rsp.data;
        if(data.results && data.results.token) {
            cb({status: 1,data: {token: data.results.token}})
        } else {
            cb({ status: 0, data: {} })
        }
    }).catch(err => {
        cb({ status: 0, data: {}, msg: err.response?.data || err.message || "Something went wrong." })
    })
}

export const openProductsForToken = (token, cb) => {
    Axios.get(`/vendor/manage-products-genio/${token}/api/getContractData.ns`).then(rsp => {
        if (rsp.data.isSuccess) {
            const inIFrame = (window.top != window.self) ? true : undefined;
            const url = `${window.location.origin}/vendor/manage-products-genio/${token}/products${inIFrame ? '?loadedInIframe=true' : ''}`;
            window.location.href = url;
        } else {
            cb && cb({ status: 0 })
        }
    }).catch(() => {
        cb && cb({ status: 0 })
    })
}

export const deleteCookie = (name) =>{
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const removeLocalStorage = (name) => {
    localStorage.removeItem(name);
}

export const ssoLogout = () => {
    removeLocalStorage("code_verifier")
    deleteCookie("obeAccessToken")
    deleteCookie("obeRefreshToken")
    const logoutUrl = "https://accounts.justdial.com/jdiam/logout"
    const inIFrame = (window.top != window.self) ? true : undefined;
    if (inIFrame) {
        window.top.location.href = logoutUrl
    } else {
        window.location.href = logoutUrl
    }
}